module.exports = __webpack_public_path__ + "img/xdwl.8b2b411c.png";